"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var appn;
(function (appn) {
    var views;
    (function (views) {
        var billing;
        (function (billing) {
            var payments;
            (function (payments) {
                class InitArgs {
                    constructor() {
                        this.paymentConfigIsValid = false;
                        this.gateway = 'PinPayments';
                        this.gatewayKey = appn.emptyString;
                        this.gatewayEnv = appn.emptyString;
                        this.entityId = appn.emptyString;
                        this.outstandingInvoices = false;
                        this.paymentsURL = appn.emptyString;
                        this.inProgressInvoiceId = appn.emptyString;
                        this.countryStates = {};
                    }
                }
                let _initArgs;
                let _$form, _$submitButton;
                let dataTable = null;
                let _stripe = null;
                let _stripeElements = null;
                let _pinHostedFields = null;
                function gateway() { return _initArgs.gateway; }
                payments.gateway = gateway;
                function init(args) {
                    _initArgs = args;
                    createDatatable();
                    appn.ui.initCountryStateDropdown({
                        countrySelector: '#address-country',
                        stateTextSelector: '#address-state',
                        stateSelectSelector: '#address-state-select',
                        countryStates: args.countryStates
                    });
                    initAndToggleForInputOrDisplay(_initArgs.paymentConfigIsValid);
                    addEvents();
                }
                payments.init = init;
                function initHostedFields() {
                    const themeSource = document.getElementById('address-line1');
                    const baseStyles = window.getComputedStyle(themeSource);
                    const placeholderStyles = window.getComputedStyle(themeSource, '::placeholder');
                    const theme = {
                        color: baseStyles.color,
                        fontFamily: baseStyles.fontFamily,
                        fontSize: baseStyles.fontSize,
                        placeholderColor: placeholderStyles.color || '#939ba2'
                    };
                    if (_initArgs.gateway === 'Stripe') {
                        _stripe = window.Stripe(_initArgs.gatewayKey);
                        const elements = _stripe.elements();
                        const stripeStyle = {
                            base: {
                                color: theme.color,
                                fontFamily: theme.fontFamily,
                                fontSize: theme.fontSize,
                                '::placeholder': {
                                    color: theme.placeholderColor
                                }
                            },
                            invalid: {
                                color: '#dc3545'
                            }
                        };
                        _stripeElements = {};
                        _stripeElements.cardNumber = elements.create('cardNumber', { style: stripeStyle });
                        _stripeElements.cardNumber.mount('#cc-number-mount');
                        _stripeElements.cardExpiry = elements.create('cardExpiry', { style: stripeStyle });
                        _stripeElements.cardExpiry.mount('#cc-expiry-mount');
                        _stripeElements.cardCvc = elements.create('cardCvc', { style: stripeStyle });
                        _stripeElements.cardCvc.mount('#cc-cvc-mount');
                        Object.keys(_stripeElements).forEach(key => {
                            _stripeElements[key].on('change', function (event) {
                                const displayError = document.getElementById(key + '-errors');
                                const $container = $(_stripeElements[key]._id || '#' + key + '-mount');
                                if (event.error) {
                                    $container.addClass('has-error').removeClass('has-success');
                                }
                                else {
                                    $container.removeClass('has-error').addClass('has-success');
                                }
                            });
                        });
                    }
                    else {
                        _pinHostedFields = window.HostedFields.create({
                            sandbox: _initArgs.gatewayEnv !== 'live',
                            autocomplete: true,
                            styles: {
                                'input': {
                                    'font-size': theme.fontSize,
                                    'font-family': theme.fontFamily,
                                    'color': theme.color
                                },
                                'input::placeholder': {
                                    'color': theme.placeholderColor
                                },
                                '.hosted-fields-invalid:not(:focus)': {
                                    'color': '#dc3545'
                                }
                            },
                            fields: {
                                name: {
                                    selector: '#cc-name-mount',
                                    placeholder: T('Card Holder Name')
                                },
                                number: {
                                    selector: '#cc-number-mount',
                                    placeholder: '1234 5678 9012 3456'
                                },
                                cvc: {
                                    selector: '#cc-cvc-mount',
                                    placeholder: '123'
                                },
                                expiry: {
                                    selector: '#cc-expiry-mount',
                                    placeholder: 'MM/YY'
                                }
                            }
                        });
                        _pinHostedFields.on('validityChange', function (event) {
                            const $container = $(event.selector);
                            if (event.valid) {
                                $container.removeClass('has-error').addClass('has-success');
                            }
                            else {
                                $container.addClass('has-error').removeClass('has-success');
                            }
                        });
                    }
                }
                function initAndToggleForInputOrDisplay(isDisplay) {
                    $('#Save, .setcc, .cancelupdatecc').toggleClass('hide', isDisplay);
                    $('.showcc, .updatecc').toggleClass('hide', !isDisplay);
                    if (isDisplay)
                        return;
                    if (!_stripeElements && !_pinHostedFields)
                        initHostedFields();
                    $('#cc-name').toggleClass('hide', !_stripeElements);
                    $('#cc-name-mount').toggleClass('hide', !!_stripeElements);
                }
                function addEvents() {
                    $('.updatecc').click(function (e) {
                        e.preventDefault();
                        initAndToggleForInputOrDisplay(false);
                    });
                    $('.cancelupdatecc').click(function (e) {
                        e.preventDefault();
                        initAndToggleForInputOrDisplay(true);
                    });
                    $.validator.ignoreUnobtrusive = true;
                    _$form = $('form#appnForm');
                    _$form.validate({
                        errorPlacement: function (error, element) {
                        },
                        highlight: function (element) {
                            const $ctlgrp = $(element).closest('.control-group');
                            $ctlgrp.removeClass('has-success').addClass('has-error');
                        },
                        success: function ($element) {
                            let ctl = $element[0].control;
                            if (ctl === null)
                                ctl = $('#' + $element[0].htmlFor);
                            const $ctlgrp = $(ctl).closest('.control-group').first();
                            $ctlgrp.removeClass('has-error').addClass('has-success');
                        }
                    });
                    $('#address-line1').rules('add', { required: true });
                    $('#address-city').rules('add', { required: true });
                    $('#address-state').rules('add', { required: true });
                    $('#address-postcode').rules('add', { required: true });
                    $('#address-country').rules('add', { required: true });
                    if (_initArgs.gateway === 'Stripe')
                        $('#cc-name').rules('add', { required: true });
                    _$submitButton = _$form.find(':submit');
                    _$form.submit(function (e) {
                        e.preventDefault();
                        if (!_$form.valid()) {
                            _$submitButton.removeAttr('disabled');
                            return;
                        }
                        _$submitButton.attr({ disabled: true });
                        if ($('#Pay').length > 0 && $('.showcc:visible').length > 0) {
                            appn.dialog.showLoading(T('Processing Payment'));
                            _$form.get(0).submit();
                            return;
                        }
                        appn.dialog.showLoading(T('Processing...please wait.'));
                        if (_initArgs.gateway === 'Stripe') {
                            _stripe.createPaymentMethod({
                                type: 'card',
                                card: _stripeElements.cardNumber,
                                billing_details: {
                                    name: $('#cc-name').val(),
                                    address: {
                                        line1: $('#address-line1').val(),
                                        line2: $('#address-line2').val(),
                                        city: $('#address-city').val(),
                                        state: $('#address-state').val(),
                                        postal_code: $('#address-postcode').val(),
                                        country: $('#address-country').val()
                                    }
                                }
                            }).then(function (result) {
                                if (result.error) {
                                    let message = result.error.error_description || result.error.message;
                                    handleError(message, result.error.messages);
                                }
                                else
                                    onCardCreateSuccess(result.paymentMethod);
                            });
                        }
                        else {
                            _pinHostedFields.tokenize({
                                publishable_api_key: _initArgs.gatewayKey,
                                address_line1: $('#address-line1').val(),
                                address_line2: $('#address-line2').val(),
                                address_city: $('#address-city').val(),
                                address_postcode: $('#address-postcode').val(),
                                address_state: $('#address-state').val(),
                                address_country: $('#address-country').val()
                            }, function (err, response) {
                                if (err) {
                                    let message = err.error_description || err.message;
                                    handleError(message, err.messages);
                                }
                                else
                                    onCardCreateSuccess(response);
                            });
                        }
                    });
                    $(document).on('click', '.btn-resetFilters', function (e) {
                        dataTable.clearSearch();
                    });
                }
                function onCardCreateSuccess(response) {
                    if (_initArgs.outstandingInvoices || _initArgs.inProgressInvoiceId)
                        appn.dialog.showLoading(T('Processing Payment'));
                    else
                        appn.dialog.showLoading(T('Validating Card'));
                    appn.ajax.post({
                        url: _initArgs.paymentsURL,
                        data: {
                            cardToken: response.id || response.token,
                            inProgressInvoiceId: _initArgs.inProgressInvoiceId,
                            entityId: _initArgs.entityId
                        },
                        done: function (result) {
                            if (result.success)
                                window.location.href = result.navToURL;
                            else if (result.cardAuthReq)
                                performCardAuth(result);
                            else
                                handleError(result.message);
                        },
                        fail: function (jqXHR, textStatus, errorThrown) {
                            handleError(errorThrown);
                        }
                    });
                }
                function performCardAuth(payment) {
                    return __awaiter(this, void 0, void 0, function* () {
                        if (_stripe) {
                            const { error, paymentIntent } = yield _stripe.confirmCardPayment(payment.cardAuthToken);
                            if (error)
                                handleError(error.message);
                            else
                                window.location.href = payment.navToURL;
                        }
                        else {
                            window.location.href = payment.cardAuthURL;
                        }
                    });
                }
                function handleError(message, messages) {
                    if (messages)
                        $.each(messages, function (index, paramError) {
                            message += `<br>${paramError.message}`;
                        });
                    appn.toast.notify(appn.toast.Type.error, message);
                    appn.dialog.hideLoading();
                    _$submitButton.removeAttr('disabled');
                    appn.hasFormSubmitAlreadyHappened = false;
                }
                function createDatatable() {
                    dataTable = appn.dataTable.create('.chargesTable', {
                        scrollY: '40vh',
                        iDisplayLength: 25,
                        oLanguage: {
                            sInfoEmpty: T('No charges processed yet')
                        },
                        bProcessing: true,
                        aaSorting: [[0, 'desc']],
                        bServerSide: true,
                        sAjaxSource: 'ChargesDataTable',
                        fnServerData: function (data) {
                            data.push({ name: 'sCustom_0', value: _initArgs.entityId });
                        },
                        aoColumns: [
                            { bSortable: false, sWidth: '15%' },
                            { bSortable: false, sWidth: '25%' },
                            { bSortable: false, sWidth: '15%' },
                            { bSortable: false, sWidth: '20%' },
                            { bSortable: false, sWidth: '25%' }
                        ],
                        fnInitComplete: function () {
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Payments <b>Date/Time, Description or Result</b> contains a keyword typed in here'));
                            appn.saveMeState.init(function () {
                                dataTable.fnDraw(false);
                            }, function () {
                                dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        }
                    });
                }
            })(payments = billing.payments || (billing.payments = {}));
        })(billing = views.billing || (views.billing = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
